import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line max-len
import { type AudiCalculationModuleWithPermissionsSpecsFragment } from '../../../../../api/fragments/AudiCalculationModuleWithPermissionsSpecs';
import {
    CreateAudiCalculationModuleDocument,
    type CreateAudiCalculationModuleMutation,
    type CreateAudiCalculationModuleMutationVariables,
} from '../../../../../api/mutations/createAudiCalculationModule';
import { type AudiCalculationModuleInitialSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import { type CompanySpecs } from '../../../AddModulePage/getAvailableModules';
import AudiCalculationModulePage from '../../AudiCalculationModulePage';
import { type ModuleImplementation } from './types';

type FormValues = AudiCalculationModuleInitialSettings;
type AudiCalculationModuleImplementation = ModuleImplementation<
    AudiCalculationModuleWithPermissionsSpecsFragment,
    FormValues
>;
type AudiCalculationModulePageProps = {
    module: AudiCalculationModuleWithPermissionsSpecsFragment;
};

type FormProps = {
    company: CompanySpecs;
};

const validator = validators.compose(validators.requiredNonEmptyString('displayName'));

const Form: AudiCalculationModuleImplementation['FormComponent'] = ({ company }: FormProps) => {
    const { t } = useTranslation(['moduleDetails']);

    return (
        <Row gutter={10}>
            <Col span={24}>
                <InputField
                    {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                    name="displayName"
                    required
                />
            </Col>
        </Row>
    );
};

const implementation: AudiCalculationModuleImplementation = {
    PageComponent: ({ module }: AudiCalculationModulePageProps) => <AudiCalculationModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.AudiCalculationModule.className'),
    FormComponent: Form,
    getValidator: () => validator,
    create: async (apolloClient, companyId, values) => {
        const settings = values;

        return apolloClient
            .mutate<CreateAudiCalculationModuleMutation, CreateAudiCalculationModuleMutationVariables>({
                mutation: CreateAudiCalculationModuleDocument,
                variables: { companyId, settings },
            })
            .then(({ data }) => data.module);
    },
    initialValues: {
        displayName: '',
    },
};

export default implementation;
